import React from "react";

import {Descriptions} from "antd";

import {ModalWindow} from "./ModalWindow";
import {createReportOverviewLink, openLinkInNewTab} from "../../../helpers";
import {Scenarios} from "../../../variants";

const recalcIntervalLabels = {
	never: "Never",
	month: "Every Month",
	quarter: "Every 3 Months",
	halfYear: "Every Half a Year",
	year: "Every Year",
};

const getOptimiseLabel = optimiseMode => {
	const option = Scenarios.getOptimiseOptions().find(item => item.value === optimiseMode);
	return option?.label || optimiseMode || "N/A";
};

export function InfoModal({isModalVisible, setModalVisible, iteration, archived = false, projectId}) {
	const workWithDate = dateStr => {
		if (!dateStr) {
			return "";
		} else {
			const options = {
				year: "numeric",
				month: "long",
				day: "numeric",
			};
			return (
				new Date(dateStr).toLocaleDateString(undefined, options) + " " + new Date(dateStr).toLocaleTimeString()
			);
		}
	};

	const getDuration = (startDateStr, finishDateStr) => {
		if (!startDateStr || !finishDateStr) {
			return "";
		}

		const getRemains = (_diff, base) => _diff % base;

		const startDate = new Date(startDateStr);
		const finishDate = new Date(finishDateStr);

		const diff = Math.abs(finishDate - startDate) / 1000;
		if (diff < 60) {
			return `${getRemains(diff, 60)} second(s).`;
		} else if (diff < 3600) {
			return `${Math.floor(diff / 60)} minute(s) ${getRemains(diff, 60)} second(s).`;
		} else if (diff < 86400) {
			return `${Math.floor(diff / (60 * 60))} hour(s) ${Math.floor(getRemains(diff / 60, 60))} minute(s) ${getRemains(diff, 60)} second(s).`;
		} else {
			return `${Math.floor(diff / (60 * 60 * 24))} day(s) ${Math.floor(getRemains(diff / (60 * 60), 24))} hour(s) ${Math.floor(getRemains(diff / 60, 60))} minute(s) ${getRemains(diff, 60)} second(s).`;
		}
	};

	const labels = {
		limit: "Limit spikes",
		exclude: "Remove spikes",
	};

	const constants = iteration?.constants || {};

	const renderExceptionReport = () => {
		if (!iteration?.report_id || !projectId) {
			return "N/A";
		}

		return (
			<a
				className="beautiful-link"
				onClick={() => openLinkInNewTab(createReportOverviewLink(projectId, iteration.report_id))}>
				{iteration.iteration_name || "Open Report"}
			</a>
		);
	};

	return (
		<ModalWindow
			title={`${iteration.iteration_name} Info`}
			isModalVisible={isModalVisible}
			modalProps={{height: "auto", maxHeight: "70vh"}}
			onOk={() => setModalVisible(false)}
			scrollVisible
			onCancel={() => setModalVisible(false)}>
			<div>
				<Descriptions bordered title="Overview Info" size={"small"}>
					<Descriptions.Item span={24} label="Created Date">
						{workWithDate(iteration.created)}
					</Descriptions.Item>
					<Descriptions.Item span={24} label="Start">
						{workWithDate(iteration.start)}
					</Descriptions.Item>
					<Descriptions.Item span={24} label="Finish">
						{workWithDate(iteration.finished)}
					</Descriptions.Item>
					<Descriptions.Item span={24} label="Duration">
						{getDuration(iteration.start, iteration.finished)}
					</Descriptions.Item>
					<Descriptions.Item span={24} label="Recalc Interval">
						{recalcIntervalLabels[constants.recalc_interval] || constants.recalc_interval || "N/A"}
					</Descriptions.Item>
				</Descriptions>
				<Descriptions style={{marginTop: 10}} bordered title="Parameters Info" size={"small"}>
					<Descriptions.Item span={24} label="Recommendation">
						{constants.selected_recommendation_label ?? "Based on ranking"}
					</Descriptions.Item>
					<Descriptions.Item span={24} label="Optimise">
						{getOptimiseLabel(constants.optimise_mode)}
					</Descriptions.Item>
					<Descriptions.Item span={24} label="Exception Report">
						{renderExceptionReport()}
					</Descriptions.Item>
					<Descriptions.Item span={24} label="Coeffcient for Demand Smoothing">
						{constants.std_coeff}
					</Descriptions.Item>
					<Descriptions.Item span={24} label="Smoothing Mode">
						{labels[constants.smoothing_mode]}
					</Descriptions.Item>
				</Descriptions>
			</div>
			{archived && (
				<Descriptions style={{marginTop: 10}} bordered title="Additional Info" size="small" column={1}>
					<Descriptions.Item labelStyle={{display: "none"}}>
						{iteration?.add_info}
					</Descriptions.Item>
				</Descriptions>
			)}
		</ModalWindow>
	);
}
